import { useRef } from 'react';

// Ref that always holds the latest `value` — read it inside an effect instead of listing
// the value itself as a dependency, so the effect only reacts to what it actually watches.
export default function useLatestRef<T>(value: T) {
  const ref = useRef(value);
  ref.current = value;
  return ref;
}
